import { NextPage } from 'next';
import { Fragment, useState } from 'react';
// -------- custom component -------- // 
import { Footer1 } from 'components/blocks/footer';
import { LocalSEO } from 'components/blocks/portfolio'; 
import NextLink from 'components/reuseable/links/NextLink';
import SEO from 'components/common/SEO'; 
import * as All from 'data/keywords';
import ProjectDetailsNavigation from 'components/common/ProjectDetailsNavigation';
import ContactFooterCombo from 'components/reuseable/ContactFooterCombo';

const details = {
  pageName: 'London Hair by Jackie',
  categories: 'seo, ppc, social, web design',
  description:
    'London Hair by Jackie is a high end wig store based in London. We were asked to design and develop a new ecommerce site for them. We also provided SEO, PPC and social media services.',
  parentDirectories: 'seo-design-portfolio'
};

const Portfolio = All.LocalSEOArrays[5].keywords;

const ProjectDetails: NextPage = () => {
  return (
    <Fragment>
      {/* <PageProgress /> */}
      {' '}
      <main className="content-wrapper">
        {/* ========== SEO META values ========== */}

        <SEO
          title={`${Portfolio[0].title} - ${details.pageName}`}
          description={details.description}
          tag={details.categories}
          urlPT={``}
urlENPT={``}
url={`${Portfolio[0].url}/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}`}
          image={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
          // updated=""
          // published=""
          // modified=""
        />

        {/* ========== heading section ========== */}
        <section
          className="wrapper image-wrapper bg-image bg-overlay text-white"
          style={{
            backgroundImage: 'url(/img/clients/' + Portfolio[1].title.toLowerCase().replace(/ /g, '-') + '-bg.jpg)',
            backgroundSize: 'cover'
          }}
        >
          <div className="container pt-17 pb-12 pt-md-19 pb-md-16 text-center">
            <div className="row">
              <div className="mx-auto">
                <div className="post-header">
                  {/* <div className="post-category text-line text-white">
                    <NextLink title="Identity" href="#" className="text-reset" />
                  </div> */}
                  <h1 className="fs-15 text-uppercase text-white mb-3">{Portfolio[0].title}</h1>
                  <p className="display-4 text-capitalize mx-auto">{details.pageName}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="wrapper bg-light wrapper-border">
          {/* ========== details section ========== */}
          <div className="container pt-14 pt-md-16 pb-13 pb-md-15">
            <div className="row">
              <div className="col-lg-12 offset-lg-0">
                <h2 className="display-6 mb-4">{details.pageName}</h2>

                <div className="row">
                  <div className="col-md-8 text-justify">
                    <p>
                      {/* <NextLinkNoAlt href={keywords[0].url} title={keywords[0].title} /> */}
                      {/* <br /> */}
                      <strong className="caption">{details.description}</strong>
                    </p>
                    <p>
                      At SEOptimist  <NextLink title={All.HomeList[0].title} href="/" />, we understand that a website is more
                      than just a collection of web pages. It's a representation of a business's brand and values, and
                      it must be designed to meet the client's goals. London Hair by Jackie is an online WooCommerce
                      store selling natural wigs.
                    </p>
                    <h3>{Portfolio[3].title}</h3>
                    <p>
                      The client approached us in February 2023 with a problem. Their website was built on an outdated
                      theme that was incompatible with their SEO requirements. Our team of WordPress SEO experts
                      analyzed their website and recommended a migration to a new theme that was more SEO-friendly and
                      could improve the site's overall performance.
                    </p>
                    <img
                      width={'100%'}
                      height={'auto'}
                      src={`/img/clients/${Portfolio[2].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                      alt={Portfolio[2].title}
                      style={{ background: 'transparent' }}
                      className="mb-5 mw"
                    />
                    <h3>{Portfolio[2].title}</h3>
                    <p>
                      We began by performing a comprehensive website audit, identifying the issues that needed to be
                      addressed, and creating a detailed migration plan. We then migrated the site to a new
                      SEO-optimized WordPress theme, ensuring that all pages, content, and data were correctly
                      transferred.
                    </p>
                    <h3>{Portfolio[1].title}</h3>
                    <p>
                      Once the migration was complete, our team implemented an on-page SEO strategy that included
                      optimizing the website's titles, meta descriptions, headers, and content to improve its relevance
                      to search engines. We also optimized the site's images, speed, and mobile-friendliness, making it
                      easier for users to navigate and find the products they were looking for.
                    </p>{' '}
                    <img
                      width={'100%'}
                      height={'auto'}
                      src={`/img/clients/${Portfolio[3].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                      alt={Portfolio[3].title}
                      style={{ background: 'transparent' }}
                      className="mb-5 mw"
                    />
                    <h3>{Portfolio[4].title}</h3>
                    <p>
                      Through our efforts, London Hair by Jackie's website has seen a significant improvement in its search
                      engine rankings (from page 5 to the top of page 2 for several terms within 8 weeks), organic traffic, and overall performance.
                      The client was thrilled with the results and reported a substantial increase in online sales.
                      SEOptimist is on target to achieve page 1 rankings within 3 months. - <em>1/04/23</em>
                    </p>
                    <p>
                      At SEOptimist  <NextLink title={All.HomeList[2].title} href="/" />, we're committed to delivering
                      measurable results to our clients. We understand that every business has unique SEO requirements,
                      and we offer customized solutions that fit their needs. Contact us today to learn more about our
                      WordPress SEO services and how we can help your business achieve success online.
                    </p>{' '}
                  </div>

                  <div className="col-md-4 ms-auto">
                    <img
                      width={250}
                      height={`auto`}
                      src={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                      alt={Portfolio[0].title}
                      style={{ background: 'transparent' }}
                      className="mb-5"
                    />
                    <ul className="list-unstyled">
                      <li>
                        <h5 className="mb-1">Categories</h5>
                        <p>{details.categories}</p>
                      </li>

                      <li>
                        <h5 className="mb-1">Client Name</h5>
                        <p>{details.pageName}</p>
                      </li>
                    </ul>
                  </div>
                  <NextLink title="Get in touch" href="/#contact" className="more hover" />
                  {/* ========== portfolio section ========== */}
                  <LocalSEO initialslide={0} />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ========== navigation section ========== */}
        <ProjectDetailsNavigation />
        </main>
      <ContactFooterCombo location="london" />
    </Fragment>
  );
};

export default ProjectDetails;
